import React from "react"

const IconJob = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36">
      <path
        fill="#BB6BD9"
        d="M30 9c.87 0 1.575.3 2.13.885.57.615.87 1.29.87 2.115v16.5c0 .825-.3 1.5-.87 2.115-.555.585-1.26.885-2.13.885H6c-.87 0-1.575-.3-2.13-.885C3.3 30 3 29.325 3 28.5V12c0-.825.3-1.5.87-2.115C4.425 9.3 5.13 9 6 9h6V6c0-.87.3-1.575.87-2.13C13.425 3.3 14.13 3 15 3h6c.87 0 1.575.3 2.13.87.57.555.87 1.26.87 2.13v3h6zM6 12v16.5h24V12H6zm15-3V6h-6v3h6z"
      ></path>
    </svg>
  )
}

export default IconJob
